import { BoxProps, ColorOptions } from '@jfs/ui-new'

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

export const styles: any = {
  DEFAULT: {
    container: {
      ...shadow,
      underlayColor: 'WHITE',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 14,
      borderWidth: 1,
      borderRadius: 4,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderColor: '#e3e6f0' as ColorOptions,
    } as BoxProps,
    listContainer: {
      ...shadow,
      backgroundColor: 'WHITE',
      padding: 16,
      underlayColor: 'WHITE',
      borderColor: '#e3e6f0' as ColorOptions,
      borderWidth: 1,
      borderTopWidth: 0,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
    } as BoxProps,
  },
  VPA: {
    container: {
      underlayColor: 'WHITE',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 14,
      borderWidth: 1,
      borderRadius: 4,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderColor: '#e3e6f0' as ColorOptions,
    } as BoxProps,
    listContainer: {
      backgroundColor: 'WHITE',
      underlayColor: 'WHITE',
      borderColor: '#e3e6f0' as ColorOptions,
      borderWidth: 1,
      borderRadius: 4,
    } as BoxProps,
  },
  SCROLLABLE: {
    container: {
      ...shadow,
      underlayColor: 'WHITE',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 14,
      borderWidth: 1,
      borderRadius: 4,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderColor: '#e3e6f0' as ColorOptions,
    } as BoxProps,
    listContainer: {
      ...shadow,
      underlayColor: 'WHITE',
    } as BoxProps,
  },
}
